import { authHttp } from '../http'
import * as routes from '../../routes/cte.routes'
import { downloadErrorHandler, errorHandler } from '../../../util/error.service'
import { parseToMysqlFormat } from '../../../util/date.service'
import { DateTime } from 'luxon'

export async function getCtesByTp(tp_id = null, pInicial, pFinal) {
  try {
    if (!pInicial || !pFinal) {
      throw new Error('Período inicial e final são obrigatórios')
    }

    const dataInicial = parseToMysqlFormat(pInicial)
    const dataFinal = parseToMysqlFormat(pFinal)

    const response = await authHttp().get(routes.urlGetCteTpId(tp_id, dataInicial, dataFinal))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function postEmitCTe(content) {
  try {
    const response = await authHttp().post(routes.urlBaseCte, content)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function deleteCancelCte(content) {
  try {
    const response = await authHttp().delete(routes.urlDeleteCancelCte, { data: content })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

// CTe Globalizado
export async function getDeliveriesForCteGlobalizado(tp_id, company_id, p_inicial, p_final) {
  try {
    const inicial = DateTime.fromJSDate(p_inicial).toFormat('yyyy-MM-dd HH:mm:ss')
    const final = DateTime.fromJSDate(p_final).toFormat('yyyy-MM-dd HH:mm:ss')
    const response = await authHttp().get(
      routes.urlGetDeliveriesForCteGlobalizado(tp_id, company_id, inicial, final),
    )
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function calcularFreteMultiplo(deliveries_ids) {
  try {
    const response = await authHttp().post(routes.urlCalcularFreteMultiplo, { deliveries_ids })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function postEmitCTeGlobalizado(content) {
  try {
    const response = await authHttp().post(routes.urlEmitCteGlobalizado, content)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

// CTe Complementar
export async function getRegrasFreteCteComplementar(cte_id) {
  try {
    const response = await authHttp().get(routes.urlRegrasFreteCteComplementar(cte_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function postEmitCTeComplementar(content) {
  try {
    const response = await authHttp().post(routes.urlEmitCteComplementar, content)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

// CTe de Substituição
export async function getDadosSubstituicaoCte(cte_id) {
  try {
    const response = await authHttp().get(routes.urlDadosSubstituicaoCte(cte_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function postEmitCteSubstituicao(content) {
  try {
    const response = await authHttp().post(routes.urlEmitCteSubstituicao, content)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

// CTe sem Nota Fiscal
export async function postEmitCteSemNota(tpId, content) {
  try {
    const response = await authHttp().post(routes.urlEmitCteSemNota(tpId), content)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getParteCteSemNota(tpId, tipo, id) {
  try {
    const response = await authHttp().get(routes.urlGetParteCteSemNota(tpId, tipo, id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getClientesCteSemNota(tpId, term) {
  try {
    const response = await authHttp().get(routes.urlGetClientesCteSemNota(tpId, term))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

// CTe de Subcontratação: CT-es de origem importados por XML
export async function getCtesOrigem(tpId, pInicial, pFinal) {
  try {
    if (!pInicial || !pFinal) {
      throw new Error('Período inicial e final são obrigatórios')
    }

    const dataInicial = parseToMysqlFormat(pInicial)
    const dataFinal = parseToMysqlFormat(pFinal)

    const response = await authHttp().get(routes.urlCtesOrigem(tpId, dataInicial, dataFinal))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

// Em erro a API devolve { message, errorObj: { erros: [{ arquivo, erro }] } }
export async function postImportarCteOrigem(tpId, arquivos) {
  try {
    const response = await authHttp().post(routes.urlImportarCteOrigem(tpId), { arquivos })
    return response.data
  } catch (error) {
    const data = error && error.response && error.response.data
    const erros =
      data && data.errorObj && Array.isArray(data.errorObj.erros) ? data.errorObj.erros : null
    if (erros && erros.length) {
      throw new Error([data.message, ...erros.map(e => `• ${e.arquivo}: ${e.erro}`)].join('\n'))
    }
    throw errorHandler(error)
  }
}

export async function deleteCteOrigem(tpId, id) {
  try {
    const response = await authHttp().delete(routes.urlCteOrigem(tpId, id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getXmlCteOrigem(tpId, id) {
  try {
    const response = await authHttp().get(routes.urlXmlCteOrigem(tpId, id), {
      responseType: 'blob',
    })
    return response.data
  } catch (error) {
    throw await downloadErrorHandler(error)
  }
}

export async function postEmitCteSubcontratacao(tpId, content) {
  try {
    const response = await authHttp().post(routes.urlEmitCteSubcontratacao(tpId), content)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}
